var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from 'react';
import { Row, Col } from '../Grid';
import { List, ListItem } from '../List';
import { Button } from '../Button';
import { CardHeader, Card } from '../Card';
import { MdKeyboardArrowRight, MdKeyboardArrowLeft } from 'react-icons/md';
import { Skeleton } from '../Loading';
export class Transfer extends React.Component {
    constructor(props) {
        super(props);
        this.fetchData = () => __awaiter(this, void 0, void 0, function* () {
            const { data } = this.props;
            const { search } = this.state;
            let items = data(search);
            if (!Array.isArray(items)) {
                this.setState({ loading: true });
                items = yield items;
                this.setState({ loading: false });
            }
            this.setState({ data: items });
        });
        this.isItemMoved = (current) => {
            const { uniqueIdentifier, values } = this.props;
            if (!values) {
                return false;
            }
            return !!values.find((v) => uniqueIdentifier(v) === uniqueIdentifier(current));
        };
        this.isItemSelected = (current, selections) => {
            const { uniqueIdentifier } = this.props;
            if (!selections) {
                return false;
            }
            return !!selections.find((v) => uniqueIdentifier(v) === uniqueIdentifier(current));
        };
        this.makeSelection = (current, key) => {
            const { uniqueIdentifier } = this.props;
            let selections = this.state[key];
            if (this.isItemSelected(current, selections)) {
                selections = selections.filter((v) => uniqueIdentifier(v) !== uniqueIdentifier(current));
            }
            else {
                selections.push(current);
            }
            const state = Object.assign(Object.assign({}, this.state), { [key]: selections });
            this.setState(state);
        };
        this.displayList = () => {
            const { data, search, loading, selectedLeft } = this.state;
            const { listDisplayProp, uniqueIdentifier, searchValue } = this.props;
            return (React.createElement(Skeleton, { isLoading: loading, render: () => (React.createElement(List, { style: { maxHeight: '300px', overflowY: 'auto' } }, data
                    .filter((v) => searchValue(v).toLowerCase().includes(search))
                    .map((v) => !this.isItemMoved(v) && (React.createElement(ListItem, { key: uniqueIdentifier(v), selected: this.isItemSelected(v, selectedLeft), onClick: () => this.makeSelection(v, 'selectedLeft') }, listDisplayProp(v)))))) }));
        };
        this.displayValue = () => {
            const { selectedRight } = this.state;
            const { listDisplayProp, uniqueIdentifier, values } = this.props;
            return (React.createElement(List, { style: { maxHeight: '300px', overflowY: 'auto' } }, values.map((v) => (React.createElement(ListItem, { key: uniqueIdentifier(v), selected: this.isItemSelected(v, selectedRight), onClick: () => this.makeSelection(v, 'selectedRight') }, listDisplayProp(v))))));
        };
        this.transfer = (to) => {
            const { onChange, values, uniqueIdentifier } = this.props;
            const { selectedLeft, selectedRight } = this.state;
            if (to === 'right') {
                onChange([...values, ...selectedLeft]);
                this.setState({ selectedLeft: [] });
                return;
            }
            onChange(values.filter((v) => !selectedRight.find((sr) => uniqueIdentifier(sr) === uniqueIdentifier(v))));
            this.setState({ selectedRight: [] });
        };
        this.state = {
            search: '',
            data: [],
            open: false,
            loading: false,
            selectedRight: [],
            selectedLeft: [],
        };
    }
    componentDidMount() {
        this.fetchData();
    }
    render() {
        const { selectedLeft, selectedRight, data } = this.state;
        return (React.createElement(Card, { elevation: this.props.elevation, style: { minWidth: '500px' } },
            React.createElement(Row, { alignItems: "center" },
                React.createElement(Col, { span: 10, alignSelf: "stretch" },
                    React.createElement(CardHeader, { subtitle: `${data.length} item(s)` }),
                    this.displayList()),
                React.createElement(Col, { span: 4 },
                    React.createElement(Button, { displayBlock: true, flat: true, disabled: !selectedLeft.length, icon: React.createElement(MdKeyboardArrowRight, null), type: "primary", onClick: () => this.transfer('right') }),
                    React.createElement(Button, { displayBlock: true, flat: true, disabled: !selectedRight.length, icon: React.createElement(MdKeyboardArrowLeft, null), type: "primary", onClick: () => this.transfer('left') })),
                React.createElement(Col, { span: 10, alignSelf: "stretch" },
                    React.createElement(CardHeader, { subtitle: `${this.props.values.length} item(s)` }),
                    this.displayValue()))));
    }
}
Transfer.defaultProps = {
    searchValue: (e) => String(e),
    elevation: 0,
};
//# sourceMappingURL=Transfer.js.map